var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.marketingJackpotData
    ? _c(
        "div",
        {
          staticClass: "marketing-jackpot",
          class: [{ "grid-view": _vm.gridView }],
          style: [
            {
              backgroundImage:
                "url(" +
                _vm.mediaServer(
                  "/static/casino/groups/" +
                    _vm.group.externalId +
                    "/assets/background/" +
                    _vm.group.externalId +
                    ".gif"
                ) +
                ")",
              minHeight: "200px"
            }
          ]
        },
        [
          _c("div", { staticClass: "group-header" }, [
            _c("div", { staticClass: "group-logo" }, [
              _c("img", {
                staticClass: "logo-holder-image",
                attrs: {
                  src: _vm.mediaServer(
                    "/static/casino/groups/" +
                      _vm.group.externalId +
                      "/assets/logo/" +
                      _vm.group.externalId +
                      ".svg"
                  ),
                  alt: _vm.jackpotName
                }
              })
            ]),
            _vm._v(" "),
            !_vm.gridView
              ? _c(
                  "div",
                  { staticClass: "see-all" },
                  [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to: {
                            name: "casino-page",
                            params: { slug: _vm.marketingJackpotData.slug }
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("Casino.See.All")))]
                    )
                  ],
                  1
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _vm.marketingJackpotData.levels &&
          _vm.marketingJackpotData.levels.length > 0
            ? _c(
                "div",
                { staticClass: "marketing-levels-container" },
                _vm._l(_vm.marketingJackpotLevelsData, function(level, i) {
                  return _c("div", { key: i, staticClass: "level-wrapper" }, [
                    level.name
                      ? _c("div", { staticClass: "level-item level-name" }, [
                          _vm._v(_vm._s(level.name))
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    level.currentValue && level.jackpot
                      ? _c("div", { staticClass: "level-item level-value" }, [
                          level.currencySymbol
                            ? _c("span", { staticClass: "currency-symbol" }, [
                                _vm._v(_vm._s(level.currencySymbol))
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("span", { staticClass: "level-amount" }, [
                            _vm._v(_vm._s(level.jackpot.formatedNumber))
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    level.startTime || level.endTime
                      ? _c(
                          "div",
                          { staticClass: "level-item level-datetime" },
                          [
                            level.countdown && i === 1
                              ? _c("span", { staticClass: "countdown" }, [
                                  _vm._v(
                                    _vm._s(
                                      level.isStartTime
                                        ? _vm.$t(
                                            "Casino.Marketing.Jackpot.Starts.In"
                                          )
                                        : _vm.$t(
                                            "Casino.Marketing.Jackpot.Ends.In"
                                          )
                                    ) +
                                      " " +
                                      _vm._s(level.countdown)
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            !level.countdown && level.formatedDate && i === 1
                              ? _c("span", { staticClass: "formated-date" }, [
                                  _vm._v(
                                    _vm._s(
                                      level.isStartTime
                                        ? _vm.$t(
                                            "Casino.Marketing.Jackpot.Starts.On"
                                          )
                                        : _vm.$t(
                                            "Casino.Marketing.Jackpot.Ends.On"
                                          )
                                    ) +
                                      " " +
                                      _vm._s(level.formatedDate)
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            level.currentValue &&
                            i === 0 &&
                            level.maxJackpotByCurrency &&
                            level.triggerType && level.triggerType !== "MBD"
                              ? _c("span", { staticClass: "jackpot-value" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("Casino.Marketing.Jackpot.Pays.At")
                                    ) +
                                      " " +
                                      _vm._s(level.currencySymbol) +
                                      _vm._s(level.maxJackpotByCurrency)
                                  )
                                ])
                              : _vm._e()
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    level.closeToWin && _vm.randomMessage
                      ? _c("div", { staticClass: "level-item level-ctw" }, [
                          _vm._v(_vm._s(_vm.randomMessage))
                        ])
                      : _vm._e()
                  ])
                }),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.marketingJackpotData.groupId
            ? _c(
                "div",
                {
                  staticClass: "slider-container",
                  attrs: {
                    "data-gid": _vm.marketingJackpotData.groupId,
                    id: "slider-container-" + _vm.marketingJackpotData.groupId
                  }
                },
                [
                  _vm.groupRender
                    ? _c("casino-slider", {
                        attrs: {
                          section: "marketing-jackpot",
                          group: _vm.setGroupItems,
                          gamesByGroup: _vm.gamesByGroup
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.gridView
                    ? _c("casino-grid-view", {
                        key: _vm.componentKey,
                        attrs: {
                          data: _vm.filterGamesInfoDataByGroup(
                            this.group.gameIds
                          ),
                          groupData: this.group
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-424a0f58", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-424a0f58","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/igaming/partials/casinoMarketingJackpots.vue
// module id = null
// module chunks = 